"use client"


import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { FormEvent, useState } from "react"
import { useRouter } from "next/navigation"
import Cookies from "js-cookie"
import { GlobalData } from "@/app/context/GlobalContext"
import { getDecodedToken, POST } from "@/helpers/ApiConfig"
import toast, { Toaster } from "react-hot-toast"
import { EyeIcon, EyeOff } from "lucide-react";
import Image from "next/image"
import AlliedLogo from "../../public/images/allied-bank-logo.png"
import ClipLoader from 'react-spinners/ClipLoader'


export function LoginForm({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"div">) {
  const { setUser } = GlobalData() || {};
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const { pageLoading } = GlobalData() || {}
  const router = useRouter()


  const handleLoginSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!username || !password) {
      toast.error('Please fill in all fields.')
      return;
    }
    if (password.length < 6) {
      toast.error('Password must contain greater than 6 characters. Try again')
      return;
    }
    if (loading) return;


    try {
      setLoading(true)
      const res = await POST("/login", { password, username: username || "testing" })
      const token = res?.data?.token


      if (token) {
        Cookies.set('user_token', `${token}`, { expires: 1 })
        const user = getDecodedToken(token);


        toast.promise(
          Promise.resolve().then(() => {
            router.push(`/${user?.role?.toLowerCase()}/map`);
            return "Login successful!";
          }),
          {
            loading: "Logging in...",
            success: "Login successful!",
            error: "Login failed"
          }
        )
      } else {
        setLoading(false)
        toast.error('Invalid credentials')
      }
    } catch (err) {
      console.error(err)
      setLoading(false)
      toast.error('Login failed')
    } finally {
      // setLoading(false)
    }
  }


  return (
    <div className={cn("flex flex-col gap-6", className)} {...props}>
      <Toaster />
      <Card>
        <CardHeader className="text-center">
          <Image className="mx-auto my-0 mb-2" alt="allied-img" src={AlliedLogo} width={70} height={70} />
          <CardTitle className="text-xl">LeadMate</CardTitle>
          {/* <CardDescription>
            Login with your Username and Password
          </CardDescription> */}
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLoginSubmit}>
            <div className="grid gap-6">
              <div className="grid gap-6">
                <div className="grid gap-2 ">
                  <Label htmlFor="email">Username</Label>
                  <Input
                    id="email"
                    type="text"
                    onChange={(e) => setUsername(e.target.value)}
                    value={username}
                    placeholder="Username"
                    required
                    className="focus:border-blue-500 outline-none focus-visible:ring-0  focus:ring-blue-500 dark:focus:border-blue-4000"
                  />

                </div>
                <div className="grid gap-2">
                  <Label htmlFor="password">Password</Label>
                  <div className="relative">
                    <Input
                      id="password"
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                      placeholder="password..."
                      type={showPassword ? "text" : "password"}
                      required
                      className="focus:border-blue-500 outline-none focus-visible:ring-0  focus:ring-blue-500 dark:focus:border-blue-4000"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-2 flex items-center"
                    >
                      {showPassword ? (
                        <EyeOff className="h-5 w-5 text-gray-500" />
                      ) : (
                        <EyeIcon className="h-5 w-5 text-gray-500" />
                      )}
                    </button>
                  </div>
                </div>
                <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-500 text-white"
                  disabled={loading || pageLoading}>
                  {loading ? <ClipLoader size={20} color="#fff" /> : "Login"}
                </Button>
              </div>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}





